import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.ko'
import yieldLadder from './yieldLadder.ko'

export default createLendingBundle({ whitepaper, yieldLadder })
